import { render, staticRenderFns } from "./AgentWMS.vue?vue&type=template&id=680a8b64&"
import script from "./AgentWMS.vue?vue&type=script&lang=js&"
export * from "./AgentWMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports